import React, { useState } from 'react';

import { MeData } from 'graphQL/Auth/types';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import ModifyContainer from '../ModifyContainer';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import ProfileThumbnail from 'components/common/ProfileThumbnail';
import { ModifyValue } from '../../hooks/useProductDetaillHooks';

interface ProfileContainerIProps {
  isMobile: boolean;
  modifyValue: ModifyValue;
  setModifyValue: React.Dispatch<React.SetStateAction<ModifyValue>>;
}

const ProfileContainer: React.FC<ProfileContainerIProps> = props => {
  const { isMobile, modifyValue, setModifyValue } = props;

  const myInfo: MeData = useUserInformation((state: any) => state.userInfo);

  return (
    <ModifyContainer
      title="프로필"
      isSelected={!isMobile && modifyValue.modifyStatus === 'profile'}
      onClick={() => {
        setModifyValue({ ...modifyValue, modifyStatus: 'profile' });
      }}
    >
      <Column gap="12px">
        <ProfileThumbnail style={{ width: '56px', height: '56px' }} />
        <Text color="#414B56" size="16px">
          {myInfo.me.host.name}
        </Text>
      </Column>
      {/* {isOpenModifyModal && renderModalContainer()} */}
    </ModifyContainer>
  );
};

export default ProfileContainer;
